<template>
  <v-dialog
    v-model="isOpen"
    :content-class="dialogClass"
    persistent
    no-click-animation
    max-width="400px">
    <v-icon
      v-if="useTriangle"
      medium
      color="#686868"
      dark
      class="stepper-cancel"
      @click="closeDialog()">cancel</v-icon>
    <div
      v-if="!useTriangle"
      class="stepper-close">
      <v-icon
        medium
        color="white"
        dark
        @click="closeDialog()">close</v-icon>
    </div>
    <inspection-status
      :curr-step="currStep"
      @start-inspection="startInspection"
      @postpone-inspection="closeDialog"
    />
  </v-dialog>
</template>

<script>
import InspectionStatus from '../components/InspectionStatus';
import { aiInspectionStatuses, aiInspectionErrorCodes } from '../options';
import { GET_AI_INSPECTION_URL } from '../queries';
import { AI_INSPECTION_URL_TIME_LIMIT, executeWithTimeLimit } from '../timeLimit';

export default {
  components: {
    InspectionStatus,
  },
  props: {
    currStep: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    isOpen: {
      get() {
        return this.currStep !== 0;
      },
      set(value) {
        return value;
      },
    },
    dialogClass() {
      if (this.useTriangle) {
        return 'stepper-dialog-triangle';
      }
      return 'stepper-dialog-normal elevation-0'; // To hide the shadow behind the close button
    },
    useTriangle() {
      if (this.currStep === 2 || this.currStep === 5) {
        return true;
      }
      return false;
    },
    appointmentId() {
      return parseInt(this.$route.params.id, 10) || 0;
    },
  },
  methods: {
    async startInspection() {
      this.isOpen = false;
      this.$store.commit('setAiInspectionLoading', true);

      this.updateAiStep(aiInspectionStatuses.AWAITING_REDIRECTION);

      const getInspectionUrl = this.$apollo.query({
        query: GET_AI_INSPECTION_URL,
        variables: {
          appointmentId: parseInt(this.$route.params.id, 10),
        },
      });

      executeWithTimeLimit(getInspectionUrl, AI_INSPECTION_URL_TIME_LIMIT)
        .then(({ data }) => {
          const url = data.generateInspectionUrl.url;
          if (url) {
            window.location.href = url;
          } else {
            throw new Error('No AI inspection URL generated');
          }
        })
        .catch(() => {
          this.$store.commit('setAiInspectionLoading', false);

          this.$store.commit('setAiInspectionStatus', {
            apollo: this.$apollo,
            appId: this.appointmentId,
            status: aiInspectionStatuses.INSPECTION_FAILED });

          this.$store.commit('setAiInspectionErrorCode', {
            apollo: this.$apollo,
            appId: this.appointmentId,
            errorCode: aiInspectionErrorCodes.URL_TIME_LIMIT });
        });
    },
    removeQueryStatus() {
      const currQuery = { ...this.$route.query };
      delete currQuery.status;
      this.$router.replace({ query: currQuery });
    },
    closeDialog() {
      this.isOpen = false;
      this.removeQueryStatus();

      if (this.currStep === 2) {
        return;
      }

      const nextStepMapping = {
        1: aiInspectionStatuses.INSPECTION_POSTPONED,
        3: aiInspectionStatuses.INSPECTION_COMPLETED,
        4: aiInspectionStatuses.INSPECTION_COMPLETED,
        5: '',
      };
      const nextStep = nextStepMapping[this.currStep];
      this.updateAiStep(nextStep);
    },
    updateAiStep(step) {
      this.$store.commit('setAiInspectionStatus', {
        apollo: this.$apollo,
        appId: this.appointmentId,
        status: step });
    },
  },
};
</script>

<style scoped>
>>> .stepper-dialog-triangle {
  align-self: flex-start;
  margin-top: 50px;
}

>>> .stepper-dialog-triangle::before {
  position: absolute;
  content: "";
  right: 160px;
  transform: translateY(-100%);
  width: 15px;
  height: 13px;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-bottom: 15px solid white;
}

/* use :has to make sure if it will display to center if not useTriangle */
.v-dialog__content:has(.stepper-dialog-triangle) {
  justify-content: right;
}

.stepper-cancel {
  position: absolute;
  right: 10px;
  top: 35px;
  z-index: 10000;
}

/* This one is to make the background of the cancel to be white, because v-icon is transparent */
.stepper-cancel::after{
  position: absolute;
  content: "";
  background-color: white;
  width: 20px; /* Define the diameter*/
  height: 20px; /* Define the diameter*/
  border-radius: 50%;
  z-index: -1;
}

>>> .stepper-dialog-normal {
  display: grid;
}

.stepper-close {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/InspectionDialog.vue